import { BaseEncoder } from "./BaseEncoder";
import { BaseObjectEncoder } from "./BaseObjectEncoder";
import { DefaultBaseObjectEncoderImpl } from "./DefaultBaseObjectEncoderImpl";

import { TenorToValueAndFixingDateImpl } from "../model/impl/TenorToValueAndFixingDateImpl";
import { Encodable } from "../model/Encodable";

import * as CubiqTS from "../index";

export class TenorToValueAndFixingDateImplEncoder implements BaseEncoder {
  public baseEncoder: BaseObjectEncoder = new DefaultBaseObjectEncoderImpl();

  private static _instance;

  private constructor() {}

  public static get Instance() {
    // Do you need arguments? Make it a regular method instead.
    return this._instance || (this._instance = new this());
  }

  public encode(encodable: TenorToValueAndFixingDateImpl, streamout: CubiqTS.ByteBuffer): void {
    this.baseEncoder.encode(encodable, streamout);

    this.baseEncoder.writeStartEncoding(streamout);

    /*Object encoding*/
    if (encodable.tenor != null) {
      this.baseEncoder.writeStartFid(1, streamout);
      this.baseEncoder.writeObject(
        false,
        TenorToValueAndFixingDateImplEncoder.fidTypeMap.get(1),
        false,
        encodable.tenor,
        streamout,
      );
      this.baseEncoder.writeEndFid(1, streamout);
    }
    /*Object encoding*/
    if (encodable.valueDate != null) {
      this.baseEncoder.writeStartFid(2, streamout);
      this.baseEncoder.writeObject(
        false,
        TenorToValueAndFixingDateImplEncoder.fidTypeMap.get(2),
        true,
        encodable.valueDate,
        streamout,
      );
      this.baseEncoder.writeEndFid(2, streamout);
    }
    /*Object encoding*/
    if (encodable.messageId != null) {
      this.baseEncoder.writeStartFid(100, streamout);
      this.baseEncoder.writeObject(
        false,
        TenorToValueAndFixingDateImplEncoder.fidTypeMap.get(100),
        false,
        encodable.messageId,
        streamout,
      );
      this.baseEncoder.writeEndFid(100, streamout);
    }
    /*Object encoding*/
    if (encodable.fixingDate != null) {
      this.baseEncoder.writeStartFid(101, streamout);
      this.baseEncoder.writeObject(
        false,
        TenorToValueAndFixingDateImplEncoder.fidTypeMap.get(101),
        true,
        encodable.fixingDate,
        streamout,
      );
      this.baseEncoder.writeEndFid(101, streamout);
    }
    /*Object encoding*/
    if(encodable.sessionOnly!=null){
        this.baseEncoder.writeStartFid(10010,streamout);
        this.baseEncoder.writeObject(false,TenorToValueAndFixingDateImplEncoder.fidTypeMap.get(10010),false,encodable.sessionOnly,streamout);
        this.baseEncoder.writeEndFid(10010,streamout);
    }
    this.baseEncoder.writeEndEncoding(streamout);
  }

  static fidTypeMap: Map<number, string> = new Map<number, string>([
    [1, "com.bcdfx.model.Tenor"],
    [2, "com.bcdfx.model.StandardDate"],
    [100, "java.lang.String"],
    [101, "com.bcdfx.model.StandardDate"],
    [10010, "java.lang.String"],
  ]);

  /**
   * Constructs the event from a given byte stream
   */
  public decode(encodable: TenorToValueAndFixingDateImpl, streamin: CubiqTS.ByteBuffer): void {
    this.baseEncoder.decode(encodable, streamin);

    while (true) {
      let ct: string = this.baseEncoder.readCtrl(streamin);
      if (ct == "^F") {
        break;
      }
      if (ct == "^H") continue;
      let fid: number = this.baseEncoder.parseCtrlAsFid(ct);
      if (this.supportsFid(fid) == false) this.baseEncoder.seekToNextFid(fid, streamin);
      switch (fid) {
        case 1: {
          /*Object encoding*/
          let val: CubiqTS.Tenor = this.baseEncoder.readObject(
            false,
            false,
            TenorToValueAndFixingDateImplEncoder.fidTypeMap.get(1),
            streamin,
          );
          encodable.tenor = <CubiqTS.Tenor>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 2: {
          /*Object encoding*/
          let val: CubiqTS.StandardDate = this.baseEncoder.readObject(
            true,
            false,
            TenorToValueAndFixingDateImplEncoder.fidTypeMap.get(2),
            streamin,
          );
          encodable.valueDate = <CubiqTS.StandardDate>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 100: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            TenorToValueAndFixingDateImplEncoder.fidTypeMap.get(100),
            streamin,
          );
          encodable.messageId = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 101: {
          /*Object encoding*/
          let val: CubiqTS.StandardDate = this.baseEncoder.readObject(
            true,
            false,
            TenorToValueAndFixingDateImplEncoder.fidTypeMap.get(101),
            streamin,
          );
          encodable.fixingDate = <CubiqTS.StandardDate>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 10010:
        {
            /*Object encoding*/
            let val_10010:string=this.baseEncoder.readObject(false,false,TenorToValueAndFixingDateImplEncoder.fidTypeMap.get(10010),streamin);
            encodable.sessionOnly=val_10010;
            this.baseEncoder.readEndFid(streamin);
            break;
        }
      }
    }
  }

  private supportsFid(fid: number): boolean {
    return TenorToValueAndFixingDateImplEncoder.fidTypeMap.has(fid);
  }
}
